import { FormEvent, useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import TelegramCard from './TelegramCard';

export default function AccountPage() {
  const { user, changePassword, updateName } = useAuth();
  const [displayName, setDisplayName] = useState(user?.displayName || '');

  useEffect(() => {
    setDisplayName(user?.displayName || '');
  }, [user?.displayName]);
  const [oldPassword, setOldPassword] = useState('');
  const [nextPassword, setNextPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const saveName = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      await updateName(displayName);
      setMessage('资料已保存');
    } catch (err) {
      setError(err instanceof Error ? err.message : '保存失败');
    }
  };

  const savePassword = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (nextPassword !== confirm) {
      setError('两次输入的新密码不一致');
      return;
    }
    try {
      await changePassword(oldPassword, nextPassword);
      setOldPassword('');
      setNextPassword('');
      setConfirm('');
      setMessage('密码已修改');
    } catch (err) {
      setError(err instanceof Error ? err.message : '修改失败');
    }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <span className="w-1.5 h-5 rounded-sm bg-accent-500" />
        我的账号
      </h1>
      <p className="mt-2 text-sm text-foreground-600">
        账号、站点和访问记录保存在服务器，可在此修改显示名称和登录密码。
      </p>

      <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="text-sm font-semibold text-foreground-900">账号信息</h2>
        <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div>
            <dt className="text-foreground-500">登录邮箱</dt>
            <dd className="mt-1 font-medium text-foreground-950">{user?.email}</dd>
          </div>
          <div>
            <dt className="text-foreground-500">注册时间</dt>
            <dd className="mt-1 font-medium text-foreground-950">
              {user?.createdAt ? new Date(user.createdAt).toLocaleString('zh-CN') : '—'}
            </dd>
          </div>
        </dl>
        <form onSubmit={saveName} className="mt-5 flex flex-col sm:flex-row gap-3">
          <input
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="显示名称（选填）"
            className="flex-1 px-4 py-2.5 rounded-md border border-background-200 text-sm"
          />
          <button
            type="submit"
            className="px-4 py-2.5 text-sm font-semibold text-background-50 bg-accent-500 rounded-md"
          >
            保存资料
          </button>
        </form>
      </section>

      <section className="mt-4 rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="text-sm font-semibold text-foreground-900">修改密码</h2>
        <form onSubmit={savePassword} className="mt-4 flex flex-col gap-3 max-w-md">
          <input
            type="password"
            required
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            placeholder="原密码"
            className="px-4 py-2.5 rounded-md border border-background-200 text-sm"
          />
          <input
            type="password"
            required
            minLength={6}
            value={nextPassword}
            onChange={(e) => setNextPassword(e.target.value)}
            placeholder="新密码，至少 6 位"
            className="px-4 py-2.5 rounded-md border border-background-200 text-sm"
          />
          <input
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="确认新密码"
            className="px-4 py-2.5 rounded-md border border-background-200 text-sm"
          />
          <button
            type="submit"
            className="w-fit px-4 py-2.5 text-sm font-semibold text-background-50 bg-accent-500 rounded-md"
          >
            更新密码
          </button>
        </form>
      </section>

      <TelegramCard token={user?.apiToken || ''} />

      {message && <p className="mt-4 text-sm text-accent-700">{message}</p>}
      {error && <p className="mt-4 text-sm text-primary-700">{error}</p>}
    </div>
  );
}
